import Card from 'design-system/components/Card';

const DashboardOrganizationEmailAddressesView = () => {
  return (
    <Card>
      <Card.Title>Email addresses</Card.Title>
    </Card>
  );
};

export default DashboardOrganizationEmailAddressesView;
